import { render } from "./HonorCalculationTable.vue?vue&type=template&id=720c42be&scoped=true"
import script from "./HonorCalculationTable.vue?vue&type=script&lang=js"
export * from "./HonorCalculationTable.vue?vue&type=script&lang=js"

import "./HonorCalculationTable.vue?vue&type=style&index=0&id=720c42be&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/WwEazHb5/0/pln-pusdiklat/ups/assessment_hc_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-720c42be"]])

export default __exports__